import { Box } from 'common/src/designSystem/components/box';
import { Flex } from 'common/src/designSystem/components/flex';
import { I } from 'common/src/designSystem/components/i';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { Row } from 'common/src/designSystem/components/table/row';
import { UserInfoTeamRightPanelFragment } from 'common/src/generated/types';
import * as React from 'react';
import { AvatarNameEmail } from '../../components/avatarNameEmail';
import { Button } from '../../designSystem/components/button';
import { useHeavent } from '../../hooks/useHeavent';
import { TeamRightPanelSlot, useTeamRightPanelContext } from './teamRightPanelContext';

interface ITeamRightPanelMemberRowProps {
    member: UserInfoTeamRightPanelFragment;
    slot: TeamRightPanelSlot;
}

export const TeamRightPanelMemberRow = (props: ITeamRightPanelMemberRowProps) => {
    const { translate } = useHeavent();
    const { assign, memberIdToAssignedSlotsIds, memberIdToWishedSlotsIds } =
        useTeamRightPanelContext();
    const [isLoading, setIsLoading] = React.useState(false);
    const isAssigned = memberIdToAssignedSlotsIds[props.member.userInfo.id].includes(props.slot.id);
    const isWished = memberIdToWishedSlotsIds[props.member.userInfo.id].includes(props.slot.id);

    return (
        <Row>
            <Cell>
                <AvatarNameEmail size={32} userInfo={props.member.userInfo} />
            </Cell>

            <Cell justify="end">
                {isAssigned ? (
                    <Flex align="center" gap="1">
                        <Box color="success500">
                            <I icon="badge-check" iconStyle="solid" />
                        </Box>
                        <Box font="gray800 textXs medium">{translate('d_j_affect_71706')}</Box>
                    </Flex>
                ) : isWished ? (
                    <Button
                        isLoading={isLoading}
                        size="sm"
                        onClick={() => {
                            setIsLoading(true);
                            assign(props.member.userInfo.id, props.slot.id);
                        }}
                    >
                        {translate('affecter_94255')}
                    </Button>
                ) : (
                    <Flex align="center" gap="1">
                        <Box color="error500">
                            <I icon="circle-xmark" iconStyle="solid" />
                        </Box>
                        <Box font="gray800 textXs medium">{translate('non_souhait_46147')}</Box>
                    </Flex>
                )}
            </Cell>
        </Row>
    );
};
